import styled from 'styled-components';
import { fontUi } from '../../../../theme/typography';

export const StyledBigBlock = styled.div`
  display: flex;
  width: 35%;
  padding: 20px 35px;
  justify-content: space-around;
  flex-direction: column;
  height: 195px;
`;
export const StyledSmallBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30%;
  padding: 20px 0;
  text-align: center;
  border-left: 1px solid ${({ theme }) => theme.borderSubtle};
  border-right: 1px solid ${({ theme }) => theme.borderSubtle};
  height: 195px;
  ${fontUi};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
  opacity: 1;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

export const StyledDot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 10px;
  background-color: ${({ isDefault, theme }) =>
    isDefault ? (theme.isDark ? '#5c5e66' : '#d9d9d9') : '#00996B'};
`;

export const StyledDotsRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ isAway }) => (isAway ? 'row' : 'row-reverse')};
`;
